import {
  Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, Inject
} from '@angular/core';
import {
  IdynamicFormItem,
  IDynamicFormItemTooltipPattern,
  IDynamicFormItemTooltipWidget
} from '@ispm/dynamic-form/interfaces/IdynamicFormItem';

import { ResolvableComponent } from '@ispm/core/decorators/resolvable-component.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import {tooltipPositions} from "@ispm/shared/directives/tooltips/tooltip.directive";
import { get, has, cloneDeep , isEmpty, set } from 'lodash';
import { GroupingAndOrderingService } from '@ispm/shared/services/grouping-and-ordering.service';
import {ConditionalItem, IConditionalItem} from "@ispm/shared/classes/conditional-item.class";
import { BehaviorSubject } from 'rxjs';


@Component({
  selector: 'gen-items-list-container',
  templateUrl: './items-list.component.html',
  styleUrls: ['./items-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@ResolvableComponent()
export class ItemsListComponent implements OnInit, IWidgetItem {

  constructor(private _changeDetector: ChangeDetectorRef,protected groupingAndOrderingService: GroupingAndOrderingService) {
  }

  set widgetConfig(_itemConfig: IdynamicFormItem) {
    this.formItems = _itemConfig.widgetPayload;
    this.items = this.formItems.displayItems;
    this.transformConfig = this.formItems.transformConfig;
    this.tableTitle = this.formItems.tableTitle;
    this.formVertical = this.formItems.formVertical;
    this.tableVertical = this.formItems.tableVertical;
    this.viewAsTable = this.formItems.viewAsTable;
    this.showCount = this.formItems.showCount;
    this.showHiddenCount = this.formItems.showHiddenCount;
    this.formId = this.formItems.formId;
    this.displayFormat = this.formItems.displayFormat;
    this.orderBy = this.formItems.orderBy;
    this.order = this.formItems.order;
    this.emptyMessageDisplay = this.formItems.emptyMessageDisplay;
    this.emptyMessageDisplay$.next(this.emptyMessageDisplay);
    this.emptyItemConditions = this.formItems.emptyItemConditions ? this.formItems.emptyItemConditions : [];
    this.setTooltipData();
  }

  set widgetData(widgetData: any) {
    this.data = cloneDeep(widgetData);
    if (!isEmpty(this.data)) {

      // allow to filter items by the configured conditions
      if (this.emptyItemConditions &&
          this.emptyItemConditions.length > 0 &&
          this.data.length > 0) {

        this.data = this.data.filter(dataItem => {
          return this.emptyItemConditions.every(condition => ConditionalItem.from(dataItem, <ConditionalItem>condition).verify());
        });

      }

      if (this.data, this.formItems.orderBy && this.formItems.order) {
        this.groupingAndOrderingService.sortDataByDate(this.data,this.formItems.orderBy,this.formItems.order)
      }

      this.dataList = this.data;
      if (this.data.length > this.showCount) {
        this.itemCount = this.showCount;
        this.tableData =  this.data.slice(0, this.showCount);
      } else {
        this.itemCount = this.data.length;
        this.tableData = this.data;
      }

    }
    else{
      //resetting the data if widgetData is undefined
      this.dataList=[];
      this.tableData=[];
    }
    this.translateDefaultUnknown(this.emptyMessageDisplay);
    this._changeDetector.markForCheck();
    this.transformData(this.tableData);
    this._changeDetector.detectChanges();
  }
  public tableData: any = [];
  public formItems: any;
  public tableTitle: string = '';
  public transformConfig: any;
  public formVertical: boolean = false;
  public tableVertical: boolean = false;
  public viewAsTable: boolean = false;
  public showCount: number;
  public showHiddenCount: boolean = false;
  public formId: string;
  public displayFormat: string;
  public itemCount: number;
  public orderBy: string;
  public order: string;
  public emptyMessageDisplay: string = '';
  public emptyMessageDisplay$ =  new BehaviorSubject<any>('');
  public emptyItemConditions: Array<IConditionalItem> = [];
  public items: any;
  public tooltipPosition: string ;
  public tooltipText: string;
  public tooltipConfiguration: IDynamicFormItemTooltipPattern | IDynamicFormItemTooltipWidget;
  public tooltipShow: boolean;
  public dataList: any = [];
  @Input()
  public data;

  ngOnInit() {

  }

  private setTooltipData() {
     this.tooltipPosition =  has(this.formItems,'tooltipConfiguration.tooltipPosition') ? get(this.formItems,'tooltipConfiguration.tooltipPosition')  : tooltipPositions.BOTTOM;
     this.tooltipConfiguration = has(this.formItems,'tooltipConfiguration') ? get(this.formItems,'tooltipConfiguration') : null;
  }

  translateDefaultUnknown(value: any){
    if (value === "Unknown" && this.emptyMessageDisplay !== `Default_${value}`) {
      this.emptyMessageDisplay = "Default_"+value;
      // Setting up value of the emptyMessageDisplay not reflecting immediately,
      // using inside settimeout causing lack in dashboard load for emptymessage
      this.emptyMessageDisplay$.next(this.emptyMessageDisplay);
      this._changeDetector.markForCheck();
      this._changeDetector.detectChanges();
    }
  }

  transformData(tableData) {
    if(this.transformConfig) {
      let newModifiedArray = Array();
      tableData.forEach((itemData, index) => {
        let tempItemData = itemData;
        if(tempItemData.text != null) {
          this.transformConfig.forEach((config, configIndex) => {
            set(tempItemData, config.destination, get(itemData, config.pickFromPath));
          });
          if(tempItemData) {
            newModifiedArray.push(tempItemData);
          }
        }
      });
      if(newModifiedArray.length > 0) {
        this.data = newModifiedArray;
        this.dataList = newModifiedArray;
      }
      if((this.data == null) || (this.data[0].text == null) || (typeof this.data[0].text.code == 'undefined')) {
        this.dataList = [];
        this.tableData = [];
      }
    }
  }

  private displaySeparator(idx){
    if(this.dataList && this.dataList.length > 0 && idx < (this.dataList.length - 1) && this.items && this.items.length > 0 &&
      (this.dataList[idx][this.items[0]]?.CommonName || this.dataList[idx][this.items[0]]?.display || this.dataList[idx][this.items[1]]?.display ||
        (this.dataList[idx][this.items[0]] && !this.dataList[idx][this.items[0]].display && !this.dataList[idx][this.items[0]].CommonName)))
      return true;

    return false;
  }
}
